<template>
  <div ref="mapEl" class="bus-stops-map"></div>
</template>

<script>
const GOOGLE_MAPS_API_KEY = 'AIzaSyDZNkn6Z3zV-QF81nHjM0-tD01lUR_Nng0'

// Snazzy Maps "Light Gray" style: https://snazzymaps.com/style/132/light-gray
const MAP_STYLE = [{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#d3d3d3"}]},{"featureType":"transit","stylers":[{"color":"#808080"},{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#b3b3b3"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"weight":1.8}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#d7d7d7"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ebebeb"}]},{"featureType":"administrative","elementType":"geometry","stylers":[{"color":"#a7a7a7"}]},{"featureType":"road.arterial","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#efefef"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#696969"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"visibility":"on"},{"color":"#737373"}]},{"featureType":"poi","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"color":"#d6d6d6"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#dadada"}]}]

let gmapsLoaderPromise = null

function loadGoogleMaps(apiKey) {
  if (window.google && window.google.maps) {
    return Promise.resolve()
  }
  if (gmapsLoaderPromise) {
    return gmapsLoaderPromise
  }
  gmapsLoaderPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Google Maps script failed to load'))
    document.head.appendChild(script)
  })
  return gmapsLoaderPromise
}

export default {
  name: 'BusStopsMap',
  props: {
    apiKey: {
      type: String,
      default: GOOGLE_MAPS_API_KEY
    },
    center: {
      type: Object,
      default: () => ({ lat: 48.20720, lng: 17.02250 })
    },
    zoom: {
      type: Number,
      default: 15
    },
    iconUrl: {
      type: String,
      default: () => require('@/assets/images/autobus.png')
    },
    iconSize: {
      type: Number,
      default: 26
    },
    logoUrl: {
      type: String,
      default: () => require('@/assets/images/bory_nove_bloky_mapa.png')
    },
    logoPosition: {
      type: Object,
      default: () => ({ lat: 48.20590590003617, lng: 17.028940803513294 })
    },
    logoSize: {
      type: Number,
      default: 80
    }
  },
  data() {
    return {
      stops: [
        { id: 'stop-1',  lat: 48.211908216597216, lng: 17.013009155581138, name: 'Veľkolúcky potok',  lines: '25, 26, 92, N21' },
        { id: 'stop-2',  lat: 48.210218809707136, lng: 17.01412569937622,  name: 'Veľkolúcky potok',  lines: '25, 26, 92, N21' },
        { id: 'stop-3',  lat: 48.20957495224774,  lng: 17.016650616486658, name: 'Mateja Encingera',  lines: '23' },
        { id: 'stop-4',  lat: 48.208832000908636, lng: 17.030806851016994, name: 'Vladimíra Jukla',  lines: '30' },
        { id: 'stop-5',  lat: 48.20826715691884,  lng: 17.028907847157754, name: 'Vladimíra Jukla',  lines: '30' },
        { id: 'stop-6',  lat: 48.20752001260616,  lng: 17.032309934359773, name: 'Nemocnica Bory',  lines: '30, 216' },
        { id: 'stop-7',  lat: 48.20727330236977,  lng: 17.03148276764486,  name: 'Nemocnica Bory',  lines: '30, 216' },
        { id: 'stop-8',  lat: 48.206776224425106, lng: 17.016908261089764, name: 'T. P. Kolakoviča',  lines: '92' },
        { id: 'stop-9',  lat: 48.2063373370134,   lng: 17.022488266423238, name: 'Hrubé lúky',  lines: '30' },
        { id: 'stop-10', lat: 48.206192421428824, lng: 17.017153023462715, name: 'T. P. Kolakoviča', lines: '92, N21' },
        { id: 'stop-11', lat: 48.20579555297072,  lng: 17.0134113151582,   name: 'Kamenáče', lines: '20' },
        { id: 'stop-12', lat: 48.20581617026303,  lng: 17.01631926811433,  name: 'T. P. Kolakoviča', lines: '20, 21, 92' },
        { id: 'stop-13', lat: 48.20572956360924,  lng: 17.023475319297017, name: 'Hrubé lúky', lines: '30' },
        { id: 'stop-14', lat: 48.204464313255826, lng: 17.033048733599383, name: 'OC Bory', lines: '36, 216' },
        { id: 'stop-15', lat: 48.203752594876576, lng: 17.033056006359192, name: 'OC Bory', lines: '21, 25, 30, 36, 92' },
        { id: 'stop-16', lat: 48.203534796886736, lng: 17.032195607805072, name: 'OC Bory', lines: '21, 25, 30, 36, 92' },
        { id: 'stop-kolakovica', lat: 48.20641708332515,  lng: 17.018498505822457, name: 'T. P. Kolakoviča', lines: '23, 30' },
        { id: 'stop-encingera',  lat: 48.210010664952634, lng: 17.016563762830472, name: 'Mateja Encingera', lines: '23' }
      ],
      map: null,
      markers: [],
      infoWindow: null,
      hoverCloseTimer: null
    }
  },
  mounted() {
    loadGoogleMaps(this.apiKey)
      .then(() => this.initMap())
      .catch(err => console.error(err))
  },
  beforeDestroy() {
    this.markers.forEach(m => m.setMap(null))
    this.markers = []
    this.map = null
  },
  methods: {
    initMap() {
      const google = window.google
      this.map = new google.maps.Map(this.$refs.mapEl, {
        center: this.center,
        zoom: this.zoom,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        clickableIcons: false,
        styles: MAP_STYLE
      })

      const icon = {
        url: this.iconUrl,
        scaledSize: new google.maps.Size(this.iconSize, this.iconSize),
        anchor: new google.maps.Point(this.iconSize / 2, this.iconSize / 2)
      }

      const bounds = new google.maps.LatLngBounds()

      this.infoWindow = new google.maps.InfoWindow({ disableAutoPan: false })

      this.markers = this.stops.map(stop => {
        const marker = new google.maps.Marker({
          position: { lat: stop.lat, lng: stop.lng },
          map: this.map,
          icon,
          title: stop.name || ''
        })

        marker.addListener('mouseover', () => this.openInfo(marker, stop))
        marker.addListener('mouseout', () => this.scheduleCloseInfo())
        marker.addListener('click', () => this.openInfo(marker, stop))

        bounds.extend(marker.getPosition())
        return marker
      })

      if (this.stops.length > 1) {
        this.map.fitBounds(bounds, 40)
      }

      new google.maps.Marker({
        position: this.logoPosition,
        map: this.map,
        clickable: false,
        optimized: false,
        zIndex: 1,
        icon: {
          url: this.logoUrl,
          scaledSize: new google.maps.Size(this.logoSize, this.logoSize),
          anchor: new google.maps.Point(this.logoSize / 2, this.logoSize / 2)
        }
      })
    },
    openInfo(marker, stop) {
      if (this.hoverCloseTimer) {
        clearTimeout(this.hoverCloseTimer)
        this.hoverCloseTimer = null
      }
      this.infoWindow.setContent(this.buildInfoContent(stop))
      this.infoWindow.open(this.map, marker)
    },
    scheduleCloseInfo() {
      if (this.hoverCloseTimer) clearTimeout(this.hoverCloseTimer)
      this.hoverCloseTimer = setTimeout(() => {
        if (this.infoWindow) this.infoWindow.close()
      }, 150)
    },
    buildInfoContent(stop) {
      const name = this.escapeHtml(stop.name || '')
      const lines = this.escapeHtml(stop.lines || '')
      const id = this.escapeHtml(stop.id || '')
      return `
        <div class="bus-stop-info" data-stop-id="${id}">
          <div class="bus-stop-info__name">${name}</div>
          <div class="bus-stop-info__lines">${lines}</div>
        </div>
      `
    },
    escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
    }
  }
}
</script>

<style scoped>
.bus-stops-map {
  width: 100%;
  height: 100%;
  min-height: 400px;
}
</style>

<style>
.bus-stop-info {
  font-family: inherit;
  min-width: 140px;
  padding: 2px 4px;
}
.bus-stop-info__name {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 4px;
  color: #222;
}
.bus-stop-info__lines {
  font-weight: 400;
  font-size: 13px;
  color: #444;
}
.gm-ui-hover-effect {
  display: none !important;
}
</style>
